import { useState, useRef, useCallback, useEffect } from 'react';

const isCurrentlyFullscreen = () =>
  !!(
    document.fullscreenElement ||
    document.webkitIsFullScreen ||
    document.mozFullScreen ||
    document.msFullscreenElement
  );

export const useFullscreen = () => {
  const [isFullScreen, setIsFullscreen] = useState(false);
  const containerRef = useRef(null);

  const handleFullscreen = useCallback(() => {
    if (isCurrentlyFullscreen()) {
      (
        document.exitFullscreen ||
        document.mozCancelFullScreen ||
        document.webkitCancelFullScreen ||
        document.msExitFullscreen
      ).call(document);
    } else {
      const el = containerRef.current;
      if (!el) return;
      (
        el.requestFullscreen ||
        el.mozRequestFullScreen ||
        el.webkitRequestFullScreen ||
        el.msRequestFullscreen
      ).call(el);
    }
  }, []);

  const exitHandler = useCallback(() => {
    setIsFullscreen(isCurrentlyFullscreen());
  }, []);

  useEffect(() => {
    const events = [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'MSFullscreenChange',
    ];
    events.forEach((e) => document.addEventListener(e, exitHandler));
    return () =>
      events.forEach((e) => document.removeEventListener(e, exitHandler));
  }, [exitHandler]);

  return { isFullScreen, containerRef, handleFullscreen };
};
